const getAdobeCloudId = () => {
  const adobeCloudCookieName = 'AMCV_A3A01F4264BFE8B00A495FA3%40AdobeOrg';

  const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length !== 2) {
      return null;
    }

    const cookie = parts[1].split(';')[0];
    return cookie ?? null;
  };

  const getMCMID = (key: string, cookieValue: string | null) => {
    if (!cookieValue) return null;

    const parts = cookieValue.split('|');
    const index = parts.indexOf(key);

    if (index === -1) return null;

    return parts[index + 1] || null;
  };

  const adobeCookieValue = getCookie(adobeCloudCookieName);

  const decodedCookie = adobeCookieValue ? decodeURIComponent(adobeCookieValue) : null;

  const mcmid = getMCMID('MCMID', decodedCookie);
  return mcmid;
};

export default getAdobeCloudId;
